import { Phone, Mail, MapPin, Facebook, MessageCircle } from 'lucide-react';

export const WHATSAPP_NUMBER = '38761810802';
export const QUOTE_MESSAGE =
  'Poštovani, zanima me vaša ponuda štampe i brendiranja. Molim vas za više informacija.';

export const whatsappLink = (text = QUOTE_MESSAGE) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const FACEBOOK_URL = 'https://www.facebook.com/garmondgraphic';
export const MAPS_LINK = 'https://maps.app.goo.gl/cySp6pRLTdYgLWCV7';
export const MAPS_EMBED =
  'https://maps.google.com/maps?cid=16611650243223566082&hl=bs&z=17&output=embed';

export const imageUrl = (file) => `/images/${encodeURI(file)}`;

export const NAV_LINKS = [
  { label: 'Usluge', href: '#usluge' },
  { label: 'Zašto Garmond', href: '#zasto-garmond' },
  { label: 'Kako radimo', href: '#kako-radimo' },
  { label: 'Portfolio', href: '#portfolio' },
  { label: 'Kontakt', href: '#kontakt' },
];

export const CONTACT_ITEMS = [
  { id: 'telefon', icon: Phone, label: 'Telefon', value: '+387 33 788 700', href: 'tel:+38733788700' },
  { id: 'telefon-2', icon: Phone, label: 'Telefon 2', value: '+387 33 788 701', href: 'tel:+38733788701' },
  { id: 'whatsapp', icon: MessageCircle, label: 'WhatsApp', value: '+387 61 810 802', href: whatsappLink() },
  { id: 'email', icon: Mail, label: 'Email', value: 'garmond@garmond.ba', href: 'mailto:garmond@garmond.ba' },
  { id: 'facebook', icon: Facebook, label: 'Facebook', value: 'Garmond Graphic', href: FACEBOOK_URL },
  {
    id: 'adresa',
    icon: MapPin,
    label: 'Adresa',
    value: 'Željeznička 112, Ilidža, Sarajevo, BiH',
    href: MAPS_LINK,
  },
];

export const WORKING_HOURS = [
  { days: 'Pon — Pet', hours: '08:00 — 16:00' },
  { days: 'Sub — Ned', hours: 'Zatvoreno' },
];
